import PropTypes from 'prop-types';

/**
 * Collection of states/provinces associated with a country
 */

/**
 * Represents a displayable country for address capture
 */

/**
 * Collection of country data keyed by country code
 */

export var CountryPropTypes = PropTypes.shape({
  cityFieldName: PropTypes.string.isRequired,
  collectStateProvince: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  postalCodeFieldName: PropTypes.string.isRequired,
  stateProvinces: PropTypes.any.isRequired
});
/**
 * Global location data, keyed by ISO Alpha-2 country code
 */
var LOCATION_DATA = {
  AF: {
    name: 'Afghanistan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AL: {
    name: 'Albania',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  DZ: {
    name: 'Algeria',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AS: {
    name: 'American Somoa',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AD: {
    name: 'Andorra',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AO: {
    name: 'Angola',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AI: {
    name: 'Anguilla',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AQ: {
    name: 'Antarctica',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AG: {
    name: 'Antigua and Barbuda',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AR: {
    name: 'Argentina',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'Municipality',
    collectStateProvince: false,
    stateProvinces: false
  },
  AM: {
    name: 'Armenia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AW: {
    name: 'Aruba',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AU: {
    name: 'Australia',
    postalCodeFieldName: 'Postcode',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: {
      AU_ACT: 'Australian Capital Territory',
      AU_NSW: 'New South Wales',
      AU_NT: 'Northern Territory',
      AU_QLD: 'Queensland',
      AU_SA: 'South Australia',
      AU_TAS: 'Tasmania',
      AU_VIC: 'Victoria',
      AU_WA: 'Western Australia'
    }
  },
  AT: {
    name: 'Austria',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  BS: {
    name: 'Bahamas',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BH: {
    name: 'Bahrain',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BD: {
    name: 'Bangladesh',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BB: {
    name: 'Barbados',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BY: {
    name: 'Belarus',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BE: {
    name: 'Belgium',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  BZ: {
    name: 'Belize',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BJ: {
    name: 'Benin',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BM: {
    name: 'Bermuda',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BT: {
    name: 'Bhutan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BO: {
    name: 'Bolivia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BA: {
    name: 'Bosnia and Herzegovina',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BW: {
    name: 'Botswana',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BV: {
    name: 'Bouvet Island',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BR: {
    name: 'Brazil',
    postalCodeFieldName: 'Cep',
    cityFieldName: 'Cidade',
    collectStateProvince: false,
    stateProvinces: false
  },
  IO: {
    name: 'British Indian Ocean Territory',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BN: {
    name: 'Brunei Darussalam',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BG: {
    name: 'Bulgaria',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BF: {
    name: 'Burkina Faso',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  BI: {
    name: 'Burundi',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KH: {
    name: 'Cambodia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CM: {
    name: 'Cameroon',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CA: {
    name: 'Canada',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: {
      CA_AB: 'Alberta',
      CA_BC: 'British Columbia',
      CA_MB: 'Manitoba',
      CA_NB: 'New Brunswick',
      CA_NL: 'Newfoundland and Labrador',
      CA_NT: 'Northwest Territories',
      CA_NS: 'Nova Scotia',
      CA_NU: 'Nunavut',
      CA_ON: 'Ontario',
      CA_PE: 'Prince Edward Island',
      CA_QC: 'Quebec',
      CA_SK: 'Saskatchewan',
      CA_YU: 'Yukon'
    }
  },
  CV: {
    name: 'Cape Verde',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KY: {
    name: 'Cayman Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CF: {
    name: 'Central African Republic',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TD: {
    name: 'Chad',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CL: {
    name: 'Chile',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'Municipality',
    collectStateProvince: false,
    stateProvinces: false
  },
  CN: {
    name: 'China',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CX: {
    name: 'Christmas Island',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CC: {
    name: 'Cocos (Keeling) Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CO: {
    name: 'Colombia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: '',
    collectStateProvince: true,
    stateProvinces: false
  },
  KM: {
    name: 'Comoros',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CG: {
    name: 'Congo',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CK: {
    name: 'Cook Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CR: {
    name: 'Costa Rica',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  HR: {
    name: 'Croatia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CU: {
    name: 'Cuba',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CY: {
    name: 'Cyprus',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CZ: {
    name: 'Czech Republic',
    postalCodeFieldName: 'Poštovní směrovací číslo',
    cityFieldName: 'Město',
    collectStateProvince: false,
    stateProvinces: false
  },
  DK: {
    name: 'Denmark',
    postalCodeFieldName: 'Postnummer',
    cityFieldName: 'By',
    collectStateProvince: false,
    stateProvinces: false
  },
  DJ: {
    name: 'Djibouti',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  DM: {
    name: 'Dominica',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  DO: {
    name: 'Dominican Republic',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TP: {
    name: 'East Timor',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  EC: {
    name: 'Ecuador',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'Locality',
    collectStateProvince: false,
    stateProvinces: false
  },
  EG: {
    name: 'Egypt',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SV: {
    name: 'El Salvador',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GQ: {
    name: 'Equatorial Guinea',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ER: {
    name: 'Eritrea',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  EE: {
    name: 'Estonia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ET: {
    name: 'Ethiopia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  FK: {
    name: 'Falkland Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  FO: {
    name: 'Faroe Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  FJ: {
    name: 'Fiji',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  FI: {
    name: 'Finland',
    postalCodeFieldName: 'Postinumero',
    cityFieldName: 'Kaupunki',
    collectStateProvince: false,
    stateProvinces: false
  },
  FR: {
    name: 'France',
    postalCodeFieldName: 'Code Postal',
    cityFieldName: 'Ville',
    collectStateProvince: false,
    stateProvinces: false
  },
  GF: {
    name: 'French Guiana',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PF: {
    name: 'French Polynesia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  FQ: {
    name: 'French Southern and Antarctic Lands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GA: {
    name: 'Gabon',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GM: {
    name: 'Gambia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GE: {
    name: 'Georgia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  DE: {
    name: 'Germany',
    postalCodeFieldName: 'Postleitzahl',
    cityFieldName: 'Stadt',
    collectStateProvince: false,
    stateProvinces: false
  },
  GH: {
    name: 'Ghana',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GI: {
    name: 'Gibraltar',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GR: {
    name: 'Greece',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  GL: {
    name: 'Greenland',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GD: {
    name: 'Grenada',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GP: {
    name: 'Guadaloupe',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GT: {
    name: 'Guatemala',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GN: {
    name: 'Guinea',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GW: {
    name: 'Guinea-Bissau',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  GY: {
    name: 'Guyana',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  HT: {
    name: 'Haiti',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  HM: {
    name: 'Heard Island and McDonald Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  HN: {
    name: 'Honduras',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  HK: {
    name: 'Hong Kong',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  HU: {
    name: 'Hungary',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  IS: {
    name: 'Iceland',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  IN: {
    name: 'India',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  ID: {
    name: 'Indonesia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  IR: {
    name: 'Iran',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  IQ: {
    name: 'Iraq',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  IE: {
    name: 'Ireland',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'County',
    collectStateProvince: true,
    stateProvinces: false
  },
  IL: {
    name: 'Israel',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'Town',
    collectStateProvince: false,
    stateProvinces: false
  },
  IT: {
    name: 'Italy',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  CI: {
    name: 'Ivory Coast',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  JM: {
    name: 'Jamaica',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  JP: {
    name: 'Japan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  JO: {
    name: 'Jordan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KZ: {
    name: 'Kazakhstan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KE: {
    name: 'Kenya',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KW: {
    name: 'Kuwait',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KG: {
    name: 'Kyrgyzstan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LA: {
    name: 'Laos',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LV: {
    name: 'Latvia',
    postalCodeFieldName: 'Pasta indekss',
    cityFieldName: 'apvidus',
    collectStateProvince: false,
    stateProvinces: false
  },
  LN: {
    name: 'Lebanon',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LS: {
    name: 'Lesotho',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LR: {
    name: 'Liberia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LY: {
    name: 'Libya',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LI: {
    name: 'Liechtenstein',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LT: {
    name: 'Lithuania',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LU: {
    name: 'Luxembourg',
    postalCodeFieldName: 'Postleitzahl',
    cityFieldName: 'Stadt',
    collectStateProvince: false,
    stateProvinces: false
  },
  MO: {
    name: 'Macau',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MK: {
    name: 'Macedonia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MG: {
    name: 'Madagascar',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MW: {
    name: 'Malawi',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MY: {
    name: 'Malaysia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MV: {
    name: 'Maldives',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ML: {
    name: 'Mali',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MT: {
    name: 'Malta',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MH: {
    name: 'Marshall Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MQ: {
    name: 'Martinique',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MR: {
    name: 'Mauritania',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MU: {
    name: 'Mauritius',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  YT: {
    name: 'Mayotte',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MX: {
    name: 'Mexico',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  FM: {
    name: 'Micronesia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MD: {
    name: 'Moldova',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MC: {
    name: 'Monaco',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MN: {
    name: 'Mongolia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ME: {
    name: 'Montenegro',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MS: {
    name: 'Montserrat',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MA: {
    name: 'Morocco',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MZ: {
    name: 'Mozambique',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  MM: {
    name: 'Myanmar',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NA: {
    name: 'Namibia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NR: {
    name: 'Nauru',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NP: {
    name: 'Nepal',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NL: {
    name: 'Netherlands',
    postalCodeFieldName: 'Postcode',
    cityFieldName: 'Gemeente',
    collectStateProvince: true,
    stateProvinces: false
  },
  AN: {
    name: 'Netherlands Antilles',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NC: {
    name: 'New Caledonia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NH: {
    name: 'New Hebrides',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NZ: {
    name: 'New Zealand',
    postalCodeFieldName: 'Postcode',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  NI: {
    name: 'Nicaragua',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NE: {
    name: 'Niger',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NG: {
    name: 'Nigeria',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NU: {
    name: 'Niue',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NF: {
    name: 'Norfolk Island',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KP: {
    name: 'North Korea',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  NO: {
    name: 'Norway',
    postalCodeFieldName: 'Postnummer',
    cityFieldName: 'Poststed',
    collectStateProvince: true,
    stateProvinces: false
  },
  OM: {
    name: 'Oman',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PK: {
    name: 'Pakistan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PW: {
    name: 'Palau',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PA: {
    name: 'Panama',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PG: {
    name: 'Papua New Guinea',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PY: {
    name: 'Paraguay',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PE: {
    name: 'Peru',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PH: {
    name: 'Philippines',
    postalCodeFieldName: 'ZIP Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: {
      PH_AB: 'Abra',
      PH_AN: 'Agusan del Norte',
      PH_AS: 'Agusan del Sur',
      PH_AK: 'Aklan',
      PH_AL: 'Albay',
      PH_AQ: 'Antique',
      PH_AP: 'Apayao',
      PH_AU: 'Aurora',
      PH_BS: 'Basilan',
      PH_BA: 'Bataan',
      PH_BN: 'Batanes',
      PH_BT: 'Batangas',
      PH_BG: 'Benguet',
      PH_BI: 'Biliran',
      PH_BO: 'Bohol',
      PH_BK: 'Bukidnon',
      PH_BU: 'Bulacan',
      PH_CG: 'Cagayan',
      PH_CN: 'Camarines Norte',
      PH_CS: 'Camarines Sur',
      PH_CM: 'Camiguin',
      PH_CP: 'Capiz',
      PH_CT: 'Catanduanes',
      PH_CV: 'Cavite',
      PH_CB: 'Cebu',
      PH_CL: 'Compostela Valley',
      PH_NC: 'Cotabato',
      PH_DV: 'Davao del Norte',
      PH_DS: 'Davao del Sur',
      PH_DO: 'Davao Oriental',
      PH_DI: 'Dinagat Islands',
      PH_ES: 'Eastern Samar',
      PH_GU: 'Guimaras',
      PH_IF: 'Ifugao',
      PH_IN: 'Ilocos Norte',
      PH_IS: 'Ilocos Sur',
      PH_II: 'Iloilo',
      PH_IB: 'Isabela',
      PH_KA: 'Kalinga',
      PH_LU: 'La Union',
      PH_LG: 'Laguna',
      PH_LN: 'Lanao del Norte',
      PH_LS: 'Lanao del Sur',
      PH_LE: 'Leyte',
      PH_MG: 'Maguindanao',
      PH_MQ: 'Marinduque',
      PH_MB: 'Masbate',
      PH_MM: 'Metropolitan Manila',
      PH_MD: 'Misamis Occidental',
      PH_MN: 'Misamis Oriental',
      PH_MT: 'Mountain',
      PH_ND: 'Negros Occidental',
      PH_NR: 'Negros Oriental',
      PH_NS: 'Northern Samar',
      PH_NE: 'Nueva Ecija',
      PH_NV: 'Nueva Vizcaya',
      PH_MC: 'Occidental Mindoro',
      PH_MR: 'Oriental Mindoro',
      PH_PL: 'Palawan',
      PH_PM: 'Pampanga',
      PH_PN: 'Pangasinan',
      PH_QZ: 'Quezon',
      PH_QR: 'Quirino',
      PH_RI: 'Rizal',
      PH_RO: 'Romblon',
      PH_SM: 'Samar',
      PH_SG: 'Sarangani',
      PH_SQ: 'Siquijor',
      PH_SR: 'Sorsogon',
      PH_SC: 'South Cotabato',
      PH_SL: 'Southern Leyte',
      PH_SK: 'Sultan Kudarat',
      PH_SU: 'Sulu',
      PH_ST: 'Surigao del Norte',
      PH_SS: 'Surigao del Sur',
      PH_TR: 'Tarlac',
      PH_TT: 'Tawi-Tawi',
      PH_ZM: 'Zambales',
      PH_ZN: 'Zamboanga del Norte',
      PH_ZS: 'Zamboanga del Sur',
      PH_ZY: 'Zamboanga-Sibugay'
    }
  },
  PN: {
    name: 'Pitcairn',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PL: {
    name: 'Poland',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'Locality',
    collectStateProvince: false,
    stateProvinces: false
  },
  PT: {
    name: 'Portugal',
    postalCodeFieldName: 'CEP',
    cityFieldName: 'Cidade',
    collectStateProvince: false,
    stateProvinces: false
  },
  QA: {
    name: 'Qatar',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  RE: {
    name: 'Reunion',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  RO: {
    name: 'Romania',
    postalCodeFieldName: 'Cod postal',
    cityFieldName: 'Oraș',
    collectStateProvince: false,
    stateProvinces: false
  },
  RU: {
    name: 'Russia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  RW: {
    name: 'Rwanda',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  WS: {
    name: 'Samoa',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SM: {
    name: 'San Marino',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ST: {
    name: 'Sao Tome and Principe',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SA: {
    name: 'Saudi Arabia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SN: {
    name: 'Senegal',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  RS: {
    name: 'Serbia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SC: {
    name: 'Seychelles',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SL: {
    name: 'Sierra Leone',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SG: {
    name: 'Singapore',
    postalCodeFieldName: 'ZIP Code',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  SK: {
    name: 'Slovakia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SI: {
    name: 'Slovenia',
    postalCodeFieldName: 'Poštna Številka',
    cityFieldName: 'Mesto',
    collectStateProvince: false,
    stateProvinces: false
  },
  SB: {
    name: 'Solomon Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SO: {
    name: 'Somalia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ZA: {
    name: 'South Africa',
    postalCodeFieldName: 'Post Code',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  KR: {
    name: 'South Korea',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ES: {
    name: 'Spain',
    postalCodeFieldName: 'ZIP Code',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  LK: {
    name: 'Sri Lanka',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  KN: {
    name: 'St. Christopher-Nevis-Anguilla',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SH: {
    name: 'St. Helena',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  LC: {
    name: 'St. Lucia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  PM: {
    name: 'St. Pierre and Miquelon',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  VC: {
    name: 'St. Vincent',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SD: {
    name: 'Sudan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SR: {
    name: 'Surinam',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SJ: {
    name: 'Svalbard and Jan Mayen',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SZ: {
    name: 'Swaziland',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SE: {
    name: 'Sweden',
    postalCodeFieldName: 'Postnummer',
    cityFieldName: 'Stad',
    collectStateProvince: false,
    stateProvinces: false
  },
  CH: {
    name: 'Switzerland',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  SY: {
    name: 'Syria',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TW: {
    name: 'Taiwan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TJ: {
    name: 'Tajikistan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TZ: {
    name: 'Tanzania',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TH: {
    name: 'Thailand',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TG: {
    name: 'Togo',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TK: {
    name: 'Tokelau Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TO: {
    name: 'Tonga',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TT: {
    name: 'Trinidad and Tobago',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TN: {
    name: 'Tunisia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TR: {
    name: 'Turkey',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TC: {
    name: 'Turks and Caicos Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  TV: {
    name: 'Tuvalu',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  UG: {
    name: 'Uganda',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  UA: {
    name: 'Ukraine',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  AE: {
    name: 'United Arab Emirates',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'Locality',
    collectStateProvince: false,
    stateProvinces: false
  },
  UK: {
    name: 'United Kingdom',
    postalCodeFieldName: 'Postcode',
    cityFieldName: 'City',
    collectStateProvince: false,
    stateProvinces: false
  },
  PU: {
    name: 'United state Miscellaneous Pacific Islands',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  US: {
    name: 'United States',
    postalCodeFieldName: 'ZIP Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: {
      US_AL: 'Alabama',
      US_AK: 'Alaska',
      US_AS: 'American Samoa',
      US_AZ: 'Arizona',
      US_AR: 'Arkansas',
      US_AA: 'Armed Forces - Americas',
      US_AE: 'Armed Forces - Europe',
      US_AP: 'Armed Forces - Pacific',
      US_CA: 'California',
      US_CO: 'Colorado',
      US_CT: 'Connecticut',
      US_DE: 'Delaware',
      US_DC: 'District of Columbia',
      US_FM: 'Federated States of Micronesia',
      US_FL: 'Florida',
      US_GA: 'Georgia',
      US_GU: 'Guam',
      US_HI: 'Hawaii',
      US_ID: 'Idaho',
      US_IL: 'Illinois',
      US_IN: 'Indiana',
      US_IA: 'Iowa',
      US_KS: 'Kansas',
      US_KY: 'Kentucky',
      US_LA: 'Louisiana',
      US_ME: 'Maine',
      US_MH: 'Marshall Islands',
      US_MD: 'Maryland',
      US_MA: 'Massachusetts',
      US_MI: 'Michigan',
      US_MN: 'Minnesota',
      US_MS: 'Mississippi',
      US_MO: 'Missouri',
      US_MT: 'Montana',
      US_NE: 'Nebraska',
      US_NV: 'Nevada',
      US_NH: 'New Hampshire',
      US_NJ: 'New Jersey',
      US_NM: 'New Mexico',
      US_NY: 'New York',
      US_NC: 'North Carolina',
      US_ND: 'North Dakota',
      US_MP: 'Northern Mariana Islands',
      US_OH: 'Ohio',
      US_OK: 'Oklahoma',
      US_OR: 'Oregon',
      US_PW: 'Palau',
      US_PA: 'Pennsylvania',
      US_PR: 'Puerto Rico',
      US_RI: 'Rhode Island',
      US_SC: 'South Carolina',
      US_SD: 'South Dakota',
      US_TN: 'Tennessee',
      US_TX: 'Texas',
      US_UT: 'Utah',
      US_VT: 'Vermont',
      US_VI: 'Virgin Islands',
      US_VA: 'Virginia',
      US_WA: 'Washington',
      US_WV: 'West Virginia',
      US_WI: 'Wisconsin',
      US_WY: 'Wyoming'
    }
  },
  UY: {
    name: 'Uruguay',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  UZ: {
    name: 'Uzbekistan',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  VA: {
    name: 'Vatican City',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  VE: {
    name: 'Venezuela',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  VN: {
    name: 'Vietnam',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  VI: {
    name: 'Virgin Islands (U.S.)',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  WF: {
    name: 'Wallis and Futana',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  EH: {
    name: 'Western Sahara',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  YE: {
    name: 'Yemen',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  YU: {
    name: 'Yugoslavia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ZR: {
    name: 'Zaire',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ZM: {
    name: 'Zambia',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  },
  ZW: {
    name: 'Zimbabwe',
    postalCodeFieldName: 'Postal Code',
    cityFieldName: 'City',
    collectStateProvince: true,
    stateProvinces: false
  }
};
export default LOCATION_DATA;